(() => {
  'use-strict';

  function initWebform(elements) {
    elements.forEach((form) => {
      // Check that the target is not already initialized
      if ('init' in form.dataset) {
        return;
      }
      form.dataset.init = true;

      form.addEventListener(
        'invalid',
        (event) => {
          form.parentElement.classList.add('-formInvalid');
          if (event.target.hasAttribute('aria-required')) {
            event.target.setAttribute('aria-invalid', 'true');
          }
        },
        true,
      );

      form.addEventListener('input', (event) => {
        if (
          event.target.hasAttribute('aria-required') &&
          event.target.checkValidity()
        ) {
          event.target.removeAttribute('aria-invalid');
        } else if (
          event.target.hasAttribute('aria-required') &&
          !event.target.checkValidity()
        ) {
          event.target.setAttribute('aria-invalid', 'true');
          validateAllRequiredFields(form);
        }
      });

      form.addEventListener(
        'blur',
        (event) => {
          if (
            event.target.hasAttribute('aria-required') &&
            !event.target.checkValidity()
          ) {
            event.target.setAttribute('aria-invalid', 'true');
            validateAllRequiredFields(form);
          }
        },
        true,
      );

      function validateAllRequiredFields(form) {
        const requiredFields = form.querySelectorAll('[aria-required]');
        requiredFields.forEach((field) => {
          if (!field.checkValidity()) {
            field.setAttribute('aria-invalid', 'true');
          }
        });
        form.parentElement.classList.add('-formInvalid');
      }

      let passwordItems = form.querySelectorAll(
        '.js-form-item-pass, .js-form-item-current-pass',
      );

      passwordItems.forEach((passwordItem) => {
        let showPasswordItems = passwordItem.querySelectorAll('.shwpd');

        showPasswordItems.forEach((showPasswordItem) => {
          showPasswordItem.innerHTML = Drupal.t('Show');
          showPasswordItem.addEventListener('click', (event) => {
            if (event.target.classList.contains('eye-open')) {
              event.target.innerHTML = Drupal.t('Hide');
            } else {
              event.target.innerHTML = Drupal.t('Show');
            }
          });
        });
      });
    });
  }

  Drupal.behaviors.validateform = {
    attach: () => {
      const forms = document.querySelectorAll('.js-validate-form');
      if (forms.length !== 0) {
        initWebform(forms);
      }
    },
  };
})();
